import type { Citation } from "../../types/agent-chat";
import { citationUrl, locatorSummary } from "./citationFormat";

const KIND_LABEL: Record<string, string> = {
  document: "Document interne",
  web: "Page web",
  cnp: "CNP 2021",
};

export interface SourcePreviewProps {
  citation: Citation;
  onOpenDocument?: (citation: Citation) => void;
}

/** Hover card body: what the source is, what it says, and how to open it. */
export function SourcePreview({ citation, onOpenDocument }: SourcePreviewProps) {
  const url = citationUrl(citation);

  return (
    <div className="text-left">
      <div className="mb-1 flex items-center gap-2">
        <span className="rounded-full bg-brand-surface px-2 py-0.5 text-[10px] font-semibold text-brand-muted">
          {KIND_LABEL[citation.kind] ?? citation.kind}
        </span>
        <span className="text-[10px] text-brand-muted">{citation.id}</span>
        {citation.score != null && (
          <span className="ml-auto text-[10px] text-brand-muted">
            pertinence {(citation.score * 100).toFixed(0)}%
          </span>
        )}
      </div>

      <p className="mb-1 text-sm font-semibold text-brand-text">{citation.title}</p>
      <p className="mb-2 text-[11px] text-brand-muted">{locatorSummary(citation)}</p>

      <p className="mb-2 line-clamp-5 text-xs text-brand-text/80">{citation.snippet}</p>

      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          className="text-xs font-semibold text-brand-accent-dk hover:underline"
        >
          Ouvrir la page ↗
        </a>
      ) : citation.kind === "document" ? (
        <button
          type="button"
          onClick={() => onOpenDocument?.(citation)}
          className="text-xs font-semibold text-brand-accent-dk hover:underline"
        >
          Voir le document
        </button>
      ) : null}
    </div>
  );
}
